import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"

export default class extends mdkController {
  static targets = ['form','profile','creditCard','finalNotice','postcode'];
  static classes = ['errorm'];
  static values = {blankmessage: String, validateflag: String};

  formTargetConnected(){
    this.toggleFormView("profile");
    this.finalNoticeTarget.hidden = true;
  }
  toggleFormView(show){
    if(show == "profile"){
      if (this.hasCreditCardTarget){
        this.creditCardTarget.hidden = true;
      }
      if (this.hasProfileTarget){
        this.profileTarget.hidden = false;
      }
    }else{
      if (this.hasCreditCardTarget){
        this.creditCardTarget.hidden = false;
      }
      if (this.hasProfileTarget){
        this.profileTarget.hidden = true;
      }
    }
  }

  validateEvent(event){
    const el = event.currentTarget;
    this.validate(el);
  }
  validate(el){
    const pa = el.parentElement;
    let errorM = pa.querySelector("."+this.errormClass);
    const flag = document.getElementById(this.validateflagValue);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    if (el.value == null || el.value == ""){
      let errorLabel = pa.parentElement.querySelector("label");
      errorM.innerHTML = errorLabel.innerText + this.blankmessageValue;
      flag.value = 'false';
    }else{
      errorM.innerHTML = null;
      flag.value = 'true';
    }
  }
  addressValidateEvent(event){
    const el = event.currentTarget;
    this.addressValidate(el);
  }
  addressValidate(el){
    const pa = el.parentElement;
    let errorM = pa.querySelector("."+this.errormClass);
    const flag = document.getElementById(this.validateflagValue);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    if(this.postcodeTarget.value != null && this.postcodeTarget.value != ""){
      if (el.value == null || el.value == ""){
        let errorLabel = pa.parentElement.querySelector("label");
        errorM.innerHTML = errorLabel.innerText + this.blankmessageValue;
        flag.value = 'false';
      }else{
        errorM.innerHTML = null;
        flag.value = 'true';
      }
    }else{
      errorM.innerHTML = null;
    }
  }
  genderValidate(){
    const genders = this.formTarget.querySelectorAll("[id^='gender']");
    let genderFlag = false;
    const flag = document.getElementById(this.validateflagValue);
    genders.forEach(function(g){
      if(g.checked == true){
        genderFlag = true;
      }
    });
    const g = genders[0];
    const pa = g.parentElement.parentElement;
    let errorM = pa.querySelector("."+this.errormClass);
    if(genderFlag == false){
      let errorLabel = pa.parentElement.querySelector("label");
      errorM.innerHTML = errorLabel.innerText + this.blankmessageValue;
      flag.value = 'false';
    }
  }

  validateAndNext(event){
    const requireColumns = this.formTarget.querySelectorAll(".require");
    const addressRequireColumns = this.formTarget.querySelectorAll(".address_require");
    const _this = this;
    const flag = document.getElementById(this.validateflagValue);
    let validateVlag = true;
    requireColumns.forEach(function(rc){
      _this.validate(rc);
      if (flag.value == 'false'){
        validateVlag = false;
      }
    });
    addressRequireColumns.forEach(function(arc){
      _this.addressValidate(arc);
      if (flag.value == 'false'){
        validateVlag = false;
      }
    });
    this.genderValidate();
    if(validateVlag == true && flag.value == 'true'){
      _this.toggleFormView("creditCard");
    }else{
      window.scroll({top: 0, behavior: 'smooth'});
    }
  }

  validateAndSubmit(event){
    const el = event.currentTarget;
    const formTarget = this.formTarget;
    const finalNoticeElem = this.finalNoticeTarget
    finalNoticeElem.hidden = true;
    this.register(function () {
      el.disabled = true;
      const formData = new FormData(formTarget);
      fetch(formTarget.action,{
        method: formTarget.method,
        body: formData
      }).then(function(response){
        el.disabled = false;
        if(response.ok){
          response.json().then(function(data){
            if(data.result == 'success'){
              window.location.href = data.url
            }else{
              finalNoticeElem.hidden = false;
              finalNoticeElem.innerText = data.message;
            }
          })
        }else{
          finalNoticeElem.hidden = false;
          finalNoticeElem.innerText = "エラーが発生しました。";
        }
      })
    });
  }

  onSubmit(){
    const flag = document.getElementById(this.validateflagValue);
    if(flag.value == 'true'){
      this.formTarget.submit();
    }
  }

  returnProfile(event){
    event.preventDefault();
    this.toggleFormView('profile');
  }
}
